import { OrganizationId } from '../../types/idFlavors';
import { buildEnergyManagerClient } from '../apiClient';
import { InstallerInvitationWithStatus } from './types';

export type CreateInstallerInvitationArgs = {
    organizationId: OrganizationId;
    email: string;
    overrideInvitation?: boolean;
};

const createInstallerInvitation = async (args: CreateInstallerInvitationArgs): Promise<void> => {
    const apiClient = buildEnergyManagerClient();

    await apiClient.post('/api/installer-invitations', args);
};

const getInstallerInvitations = async (organizationId: OrganizationId): Promise<InstallerInvitationWithStatus[]> => {
    const apiClient = buildEnergyManagerClient();

    const response = await apiClient.get<InstallerInvitationWithStatus[]>(
        `/api/installer-invitations?organizationId=${organizationId}`
    );

    return response.data;
};

export const InstallerInvitationService = {
    createInstallerInvitation,
    getInstallerInvitations,
};
